module.exports = "files/pageBackground.png";